import CompanyPropertyImportContent from "../../features/companyProperties/widgets/CompanyPropertyImportContent";

function CompanyPropertyImportScreen() {
  return <CompanyPropertyImportContent />;
}

export default CompanyPropertyImportScreen;
